import { UserOutlined, HomeOutlined, CalculatorOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import React, { useState, useEffect } from 'react';
import { Layout, Button } from 'antd';
import { Typography } from 'antd';
import logoIcon from '../img/house_logo.png';
import { useNavigate, useLocation } from 'react-router-dom';

const { Title } = Typography;
const { Sider, Content } = Layout;

const logoStyle = {
    backgroundColor: '#fff',
};

const logoButtonStyle = {
    borderRadius: '0px',
    border: 'solid 0px black',
    fontSize: '15px',
    color: '#000'
};

const navStyle = {
    justifyContent: 'center',/*flex-end, flex-start*/
    margin: '0px',
    width: '100%',
};

const items = [
    {
        label: 'Buyers',
        key: '',
        icon: <CalculatorOutlined />
    },
    {
        label: 'Sellers',
        key: 'Seller',
        icon: <CalculatorOutlined />
    }
];

const Nav = () => {
    const navigate = useNavigate();
    const location = useLocation(); // ✅ Get current path

    // ✅ Dynamically set the current menu item based on URL
    const [current, setCurrent] = useState(location.pathname.replace("/", "") || "");

    useEffect(() => {
        setCurrent(location.pathname.replace("/", "") || "");
    }, [location]); // ✅ Update state when location changes

    const onClick = (e) => {
        setCurrent(e.key);
        navigate('/' + e.key);
    };

    return (
        <Layout>
            <Sider width="40%" style={logoStyle}>
                <span
                    style={{
                        fontSize: "15px",
                        fontFamily: "cursive, Helvetica, sans-serif",
                    }}
                >
                    <Button style={logoButtonStyle}>MyPropertyScope.com</Button>
                    For Smarter Real Estate Decisions
                </span>
            </Sider>

            <Layout>
                {/* ✅ Ensure selectedKeys dynamically updates */}
                <Menu
                    selectedKeys={[current]}
                    onClick={onClick}
                    mode="horizontal"
                    items={items}
                    style={navStyle}
                />
            </Layout>
        </Layout>
    );
};

export default Nav;
